
export class SongToDeleteDTO {
  constructor (id) {
    this.id = id;
  }
}
